let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("axSk9")).then(() => parcelRequire('43aBg'));